import * as moment from 'moment';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { SelectItem } from 'primeng/api';
import { TrainingEventDetailsResponse } from 'app/models/ss-api/responses/training.event.details.response';
import { ssApiService } from 'app/services/ss-api.service';
import { MemberDesignerLicenseBasicsResponseArray, MemberDesignersLicensesBasicsResponse } from 'app/models/ss-api/responses/member.designers.licenses.basics.response';
import { MemberDesignersLicenseItem, MemberDesignersLicenseItemArray } from 'app/models/ss-api/responses/member.designers.license.item';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { GlobalServices } from '../../services/global.service';
import { TrainingEvent } from '../../models/domain/training.event';
import { RegisterForTrainingEventRequest } from '../../models/ss-api/requests/register.for.training.event.request';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface IEventRegistrationDialogModel {
  title: string;
  subTitle: string;
  event: TrainingEvent;
  minimumVersionv2: string;
  minimumVersionv3: string;
  currentVersion: string;
  licenseID?: Number;
}

@Component({
  selector: 'event-registration-dialog',
  styleUrls: ['./event-registration-dialog.component.scss'],
  templateUrl: './event-registration-dialog.component.html',
  encapsulation: ViewEncapsulation.None
})

export class EventRegistrationDialogComponent implements OnInit {
  confirmTitle = 'Register Now';
  confirmMessage = 'Would you like to register for this class?';

  successTitle = "You're In!";
  successMessage = "We've sent you an email confirming your registration.";

  errorTitle = 'All Set';

  cancelledTitle = 'Canceled';
  cancelledMessage = 'Your request has been canceled.';

  isBusy = true;

  title: string;
  subTitle: string;
  message: string;

  windowTitle: string;
  versionNum: string;
  eventDescription: string;
  softwarePackages: string;
  minVersionDisplay: string;

  isPoolStudio = false;
  isVizTerra = false;
  isVip3D = false;

  eventID: any;

  isExpired = false;

  Licenses: MemberDesignerLicenseBasicsResponseArray;
  LicensesSelectItems: SelectItem[] = new Array<SelectItem>();
  SelectedLicense: MemberDesignersLicensesBasicsResponse;

  eventData: TrainingEventDetailsResponse = new TrainingEventDetailsResponse();

  minimumVersionv2: string;
  minimumVersionv3: string;
  currentVersion: string;
  event: TrainingEvent = new TrainingEvent();
  productIcons = '<img src="/assets/images/icons/logo-icons-pool-studio.png" alt="Pool Studio" title="Pool Studio">';
  eventDate: String = '';
  eventTime: String = '';
  licenseID: Number;
  howConnect: boolean;
  whatNeed: boolean;

  result: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService,
    private gb: GlobalServices
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.title = this.config.data.title;
    this.subTitle = this.config.data.subTitle;
    this.event = this.config.data.event;
    this.minimumVersionv2 = this.config.data.minimumVersionv2;
    this.minimumVersionv3 = this.config.data.minimumVersionv3;
    this.currentVersion = this.config.data.currentVersion;

    this.getLicenses();
    this.eventDate = moment(this.event.EventDateTime).format('dddd, MMMM Do YYYY');
    this.eventTime = moment(this.event.EventDateTime).format('hh:mm a') + ' to ' + moment(this.event.EventDateTime).add(moment(this.event.TrainingClass.ClassDuration, 'hh:mm:ss').hours(), 'hours').format('hh:mm a');
    this.windowTitle = this.event.TrainingClass.ClassTitle;
    this.productIcons = this.generateProductIcons();
  }

  close() {
    this.ref.close();
  }

  // getEventData(event: TrainingEvent) {
  //   let disposable = this.api.GetTrainingEventByID(ScheduleID).subscribe(response => {
  //     this.isBusy = false;

  //     this.event = response.Data;
  //     this.eventDate = moment(this.event.EventDateTime).format("dddd, MMMM Do YYYY");
  //     this.eventTime = moment(this.event.EventDateTime).format("hh:mm a") + " to " + moment(this.event.EventDateTime).add(moment(this.event.TrainingClass.ClassDuration, "hh:mm:ss").hours(), 'hours').format("hh:mm a");
  //     this.windowTitle = this.event.TrainingClass.ClassTitle;
  //     this.productIcons = this.generateProductIcons();
  //     console.log(this.event);
  //     disposable.unsubscribe();
  //   })
  // }

  getLicenseData(e, val) {

  }

  generateProductIcons() {
    let productHTML = '';
    this.productIcons = '';
    this.softwarePackages = '';
    this.event.TrainingClass.ProductIDs.forEach((product) => {
      let img = '';
      let name = '';
      switch (product) {
        case 3:
          name = 'Vip3D';
          img = '../../assets/images/icons/logo-icons-vip3d-xs.png';
          break;
        case 2:
          name = 'Pool Studio';
          img = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
          break;
        case 1:
          name = 'VizTerra';
          img = '../../assets/images/icons/logo-icons-vizterra-xs.png';
          break;
        default:
          return false;
      }
      if (this.softwarePackages.length > 0) {
        this.softwarePackages += ' or ';
      }
      this.softwarePackages += '<strong>' + name + '</strong> ';
      productHTML += '<img class="event-software-icon" src="' + img + '" />';
    }, this);
    return productHTML;
  }

  getLicenses() {
    const subscription = this.api.MemberDesignersLicensesBasics().subscribe(
      async data => {
        subscription.unsubscribe();

        if (!data.Result) {
          // Error
          this.isBusy = false;

          await Swal.fire(
            {
              title: 'Error',
              text: 'You do not have the proper membership for this class.',
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
            .then(() => { }, () => { }); // keep this line to prevent promise error;

          this.close();
          return;
        }

        this.Licenses = data.Data;
        this.populateLicenses();
        this.isBusy = false;

      },
      error => {
        this.isBusy = false;
      });

  }

  populateLicenses() {
    if (this.Licenses == undefined || this.Licenses.length == 0)
      return;

    this.Licenses.forEach(member => {
      member.Keys.forEach(key => {
        if (!key || key.LicenseStatus.toLowerCase() == 'cancelled' || this.event.TrainingClass.ProductIDs.indexOf(key.Product_ID) < 0)
          return;

        //Check Min/Max Versions
        if (this.event.TrainingClass.MinimumSoftwareVersionInt != 0 && key.SoftwareVersionInt < this.event.TrainingClass.MinimumSoftwareVersionInt)
          return;

        if (this.event.TrainingClass.MaximumSoftwareVersionInt != 0 && key.SoftwareVersionInt > this.event.TrainingClass.MaximumSoftwareVersionInt)
          return;

        if (this.licenseID && this.licenseID != key.ID)
          return;

        this.LicensesSelectItems.push(
          {
            label: key.Key + ' - ' + key.Product + ' - ' + member.Name + ' - ' + member.Email,
            value: this.getMemberDesignerItem(member, key)
          });
      });
    });
    if (this.LicensesSelectItems.length < 1) {
      Swal.fire({
        icon: 'error',
        title: 'No active licenses for this class',
        text: 'Please select a different class'
      });
      this.close();
    } else {
      this.SelectedLicense = this.LicensesSelectItems[0].value;
    }
  }

  // ProductNotForClass(key: MemberDesignersLicenseItem) : Boolean {
  //   let names = [];
  //   this.event.TrainingClass.ProductIDs.forEach(function(product) {
  //     switch(product) {
  //       case 5:
  //         names.push('VIP3D');
  //       case 8:
  //         names.push("Pool Studio");
  //       case 9:
  //         names.push("VizTerra");
  //     }
  //   })
  // }

  isPastDue(): boolean {
    var pastDue = false;
    if (this.SelectedLicense) {
      if (this.SelectedLicense.Keys[0].PastDue) {
        pastDue = true;
      }
    }
    return pastDue;
  }

  isTOS(): boolean {
    var tos = false;
    if (this.SelectedLicense) {
      if (this.SelectedLicense.Keys[0].TOS) {
        tos = true;
      }
    }
    return tos;
  }

  isRegistered(): boolean {
    var registered = false;
    if (this.SelectedLicense) {
      if (this.SelectedLicense.Keys[0].Registered) {
        registered = true;
      }
    }
    return registered;
  }

  isValidVersion() {
    if (this.SelectedLicense) {
      if (this.SelectedLicense.Keys[0].SoftwareVersion.slice(0, 2) == "2.") {
        //v2 check
        this.minVersionDisplay = this.minimumVersionv2;
        return this.SelectedLicense.Keys[0].SoftwareVersion.slice(0, 4) >= this.minimumVersionv2.slice(0, 4);
      }
      else {
        //todo:  v3 check
        console.log("v3 check");
        console.log(this.minimumVersionv3, "mv3");
        this.minVersionDisplay = this.minimumVersionv3;

        var installedMajor = 0;
        var installedMinor = 0;
        var installedPatch = 0;
        var minimumMajor = 0;
        var minimumMinor = 0;
        var minimumPatch = 0;

        var aryInstalled = this.SelectedLicense.Keys[0].SoftwareVersion.split(".");
        installedMajor = parseInt(aryInstalled[0]);
        if (aryInstalled.length > 1)
          installedMinor = parseInt(aryInstalled[1]);
        if (aryInstalled.length > 2)
          installedPatch = parseInt(aryInstalled[2]);

        var aryMinimum = this.minimumVersionv3.split(".");
        minimumMajor = parseInt(aryMinimum[0]);
        if (aryMinimum.length > 1)
          minimumMinor = parseInt(aryMinimum[1]);
        if (aryMinimum.length > 2)
          minimumPatch = parseInt(aryMinimum[2]);

        var OldVersion = (installedMajor < minimumMajor)
          || (installedMajor == minimumMajor && installedMinor < minimumMinor)
          || (installedMajor == minimumMajor && installedMinor == minimumMinor && installedPatch < minimumPatch);

        return !OldVersion;
      }
    }
  }

  CheckKeyProduct(product: string) {
    if (product.toLowerCase() == 'vip3d' && this.isVip3D)
      return true;

    if (product.toLowerCase() == 'vizterra' && this.isVizTerra)
      return true;

    if (product.toLowerCase() == 'pool studio' && this.isPoolStudio)
      return true;

    if (product.toLowerCase() == 'poolstudio' && this.isPoolStudio)
      return true;
  }

  setWindowTitle(newHtmlContent) {
    if (newHtmlContent == undefined)
      return;

    let newWindowTitle = newHtmlContent.substr(4, newHtmlContent.indexOf('<s') - 4);
    this.windowTitle = newWindowTitle;

    let stringChop = [];
    stringChop.push(newHtmlContent.indexOf('<span class=\"version\">'));
    stringChop.push(newHtmlContent.indexOf('</span>'));

    let newVersionNum = newHtmlContent.substr(stringChop[0], stringChop[1] - stringChop[0]);
    newVersionNum = newVersionNum.replace('<span class=\"version\">', '');
    this.versionNum = newVersionNum;
  }

  setSoftwareOptions(softwareOptions: string) {
    if (softwareOptions == undefined)
      return;
    let newSoftwarePackages = softwareOptions.replace('&', 'or');
    softwareOptions = softwareOptions.replace('& ', '');
    let strings = softwareOptions.split(' ');
    this.softwarePackages = newSoftwarePackages;

    for (let i = 0; i < strings.length; i++) {
      if (strings[i] == 'Pool')
        this.isPoolStudio = true;

      if (strings[i] == 'VizTerra')
        this.isVizTerra = true;

      if (strings[i] == 'Vip3D')
        this.isVip3D = true;
    }
  }

  setEventDescription(htmlData: string) {
    if (htmlData == undefined)
      return;

    let newDescription = htmlData;
    let stringChop = [];

    stringChop.push(newDescription.indexOf('<section class="text">'));
    newDescription = newDescription.substr(stringChop[0]);

    this.eventDescription = newDescription;

  }

  getMemberDesignerItem(member: MemberDesignersLicensesBasicsResponse, license: MemberDesignersLicenseItem) {

    // merge the right data
    const data = new MemberDesignersLicensesBasicsResponse();

    data.Email = member.Email;
    data.Name = member.Name;
    data.Phone = member.Phone;

    data.Keys = new MemberDesignersLicenseItemArray();
    data.Keys.push(new MemberDesignersLicenseItem());

    data.Keys[0].CompatibilityToken = license.CompatibilityToken;
    data.Keys[0].Key = license.Key;
    data.Keys[0].Product = license.Product;
    data.Keys[0].ID = license.ID;
    data.Keys[0].SoftwareVersion = license.SoftwareVersion;
    data.Keys[0].PastDue = license.PastDue;
    data.Keys[0].TOS = license.TOS;
    data.Keys[0].Registered = license.Registered;


    return data;
  }

  getRequest(): RegisterForTrainingEventRequest {

    const request = new RegisterForTrainingEventRequest();
    let member;

    // because there is a bug on selected items we have to make sure
    // that the value is a valid object
    if (this.SelectedLicense == undefined)
      // we didnt select an object, take the 1st
      member = this.LicensesSelectItems[0].value;
    else
      // we selected an object. check if the data is in value or not
      member = <any>this.SelectedLicense;

    request.AlternateEmail = "";
    request.AlternatePhone = "";
    request.LicenseID = member.Keys[0].ID;
    request.TrainingEventID = this.event.ID;
    return request;
  }

  confirm() {

    const request = this.getRequest();

    confirm;
    Swal.fire({
      title: this.confirmTitle,
      text: this.confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to process
        return this.api.RegisterForTrainingEvent(request).toPromise();
      }
    })
      .then(
        (response: any) => {

          // init dialog vars
          let cType = 'success';
          let cTitle = this.successTitle;
          let cMessage = this.successMessage;

          if (response.isDismissed) {
            cType = 'error';
            cTitle = this.cancelledTitle;
            cMessage = this.cancelledMessage;
          } else if (!response.value || !response.value.Result) {
            // not ok
            cType = 'error';
            cTitle = this.errorTitle;
            cMessage = response.value.Message;
          }

          if (cMessage == "New License") {
            // show custom result
            Swal.fire(
              {
                title: "New License",
                html: "<div>Before registering for this advanced class, please attend a Fundamentals Workshop. If you have any questions, give us a call at 702-433-0274.</div>",
                icon: cType as SweetAlertIcon,
                showCancelButton: false,
                showConfirmButton: true
              })
              .then(() => { this.result = true; this.close(); }, () => { this.close(); }); // keep this line to prevent promise error;
          } else {
            // show result
            Swal.fire(
              {
                title: cTitle,
                text: cMessage,
                icon: cType as SweetAlertIcon,
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1500
              })
              .then(() => { this.result = true; this.close(); }, () => { this.close(); }); // keep this line to prevent promise error;
          }

        },
        (dismiss) => {
          if (dismiss === 'cancel') {

            if (!confirm)
              return;

            // show cancelled
            Swal.fire({
              title: this.cancelledTitle,
              text: this.cancelledMessage,
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000
            })
              .then(() => { this.close(); }, () => { this.close(); }); // keep this line to prevent promise error;
          }
        });

    this.result = true;
  }

  cancel() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = false;
    this.close();
  }

  toggleIsBusy() {
    this.isBusy = !this.isBusy;
  }

  RegistrationAvailable(): boolean {
    if (this.eventData.IsExpired)
      return false;

    //out of date
    if (!this.isValidVersion() && this.SelectedLicense)
      return false;

    //past due license
    if (this.isPastDue())
      return false;

    //tos
    if (this.isTOS())
      return false;

    if (!this.isRegistered())
      return false;

    return true;
  }

}
